import type { Language } from "@/data/model/Enums";
import type { ICurrentIdentityService } from "@/data/services/CurrentIdentityService";

import { clientLanguage } from "@/shared/localization/language";

import { OperatorClient } from "@/operator/OperatorClient";

export class OperatorCurrentIdentityService implements ICurrentIdentityService {
    public getIdentityId(): string | undefined {
        return OperatorClient?.context?.profile?.identityId;
    }

    public getLanguage(): Language {
        return clientLanguage();
    }
}
